import React from 'react';

import { FeatureToggles, useConfig } from '../../defaultConfig';

type Props = {
    featureToggleKey?: keyof FeatureToggles;
} & React.PropsWithChildren;

const HideWidgetOnFeatureToggle: React.FC<Props> = ({ featureToggleKey, children }) => {
    const { featureToggles } = useConfig();
    if (!featureToggleKey) return children;
    if (featureToggleKey && !featureToggles[featureToggleKey]) return null;
    return children;
};

export default HideWidgetOnFeatureToggle;
